/*
 * Combine all reducers into one to create one single state.
 */
import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import account from './account'
import appState from './appState'
import crew from './crew'
import docs from './docs'
import gear from './gear'
import ica from './ica'
import jobs from './jobs'
import location from './location'
import modal from './modal'
// import paymentDetails from './payment-details'
import personal from './personal'

export default combineReducers({
    account,
    appState,
    crew,
    docs,
    gear,
    ica,
    jobs,
    location,
    modal,
    // paymentDetails,
    personal,

    routing: routerReducer,
})



// WEBPACK FOOTER //
// ./app/reducers/index.js